function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19.9 21H22L12 3 2 21H19.9zM8.2 13.9L12 7l3.8 6.9L12 12l-3.8 1.9z",
  fill: "currentColor"
});

function SvgLocationPeak(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPeak);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48ZyBzdHlsZT0iZmlsbDpub25lIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik0xOS45IDIxTDIyIDIxIDEyIDMgMiAyMSA0LjEgMjEgMTkuOSAyMVpNOC4yIDEzLjlMMTIgNyAxNS44IDEzLjkgMTIgMTIgOC4yIDEzLjlaIi8+PC9nPjwvZz48L3N2Zz4K";
export { ForwardRef as ReactComponent };